( function ( _s ) {
	_s.fn.quoteModule = function () {
		return this.el.forEach( el => {
			const _quoteModule = _s( el );
			const _splideTrack = _quoteModule.find( '.splide__track' );

			if ( ! _quoteModule.find( '.author-picture' ).length ) {
				_quoteModule.find( '.splide__slide' ).addClass( 'pt-0' );
			}

			_s( window ).on(
				'resize',
				window.debounce( e => {
					if ( _splideTrack.length ) {
						_splideTrack.removeClass( 'no-shadow' );
					}
				}, 500 )
			);

			_s( window ).on( 'resize', () => {
				if ( ! _splideTrack.hasClass( 'no-shadow' ) ) {
					_splideTrack.addClass( 'no-shadow' );
				}
			} );
		} );
	};

	_s( document ).ready( () => {
		const _elements = _s( '.quote-module' );

		if ( _elements.length ) {
			_elements.quoteModule();
		}
	} );
} )( window._s );
